import MyCustomValidation from "../Js/Validation";
import { ref } from "vue";
import type { Ref } from "vue";

export interface ITblMStaffData {
  pkCompanyCode?: string;
  pkOfficeCode?: string;
  pkServiceType?: string;
  staffCode?: string;
  staffName?: string;
  address1?: string;
  address2?: string;
  address3?: string;
  tel?: string;
  fax?: string;
  email?: string;
  birthday?: Date | null;
  kaisibi?: Date | null;
  syuryobi?: Date | null;
  staffKana?: string;
  sikakuKbn?: number;
  koyoKeitai?: number;
  delFlg?: number;
  addDate?: Date;
  addUser?: string;
  updDate?: Date;
  updUser?: string;
}

export class TblMStaff {
  pkCompanyCode?: string;
  pkOfficeCode?: string;
  pkServiceType?: string;
  staffCode?: string;
  staffName?: string;
  address1?: string;
  address2?: string;
  address3?: string;
  tel?: string;
  fax?: string;
  email?: string;
  birthday?: Date | null;
  kaisibi?: Date | null;
  syuryobi?: Date | null;
  staffKana?: string;
  sikakuKbn?: number;
  koyoKeitai?: number;
  delFlg?: number;
  addDate?: Date;
  addUser?: string;
  updDate?: Date;
  updUser?: string;

  constructor(data: ITblMStaffData = {}) {
    this.pkCompanyCode = data.pkCompanyCode || "";
    this.pkOfficeCode = data.pkOfficeCode || "";
    this.pkServiceType = data.pkServiceType || "";
    this.staffCode = data.staffCode || "";
    this.staffName = data.staffName || "";
    this.address1 = data.address1 || "";
    this.address2 = data.address2 || "";
    this.address3 = data.address3 || "";
    this.tel = data.tel || "";
    this.fax = data.fax || "";
    this.email = data.email || "";
    this.staffKana = data.staffKana || "";
    this.sikakuKbn = data.sikakuKbn || 0;
    this.birthday = data.birthday || null;
    this.kaisibi = data.kaisibi || null;
    this.syuryobi = data.syuryobi || null;
    this.koyoKeitai = data.koyoKeitai || 0;

    this.delFlg = data.delFlg || 0;
    this.addDate = data.addDate || new Date();
    this.addUser = data.addUser || "";
    this.updDate = data.updDate || new Date();
    this.updUser = data.updUser || "";
  }

  clear(): void {
    this.pkCompanyCode = "";
    this.pkOfficeCode = "";
    this.pkServiceType = "";
    this.staffCode = "";
    this.staffName = "";
    this.address1 = "";
    this.address2 = "";
    this.address3 = "";
    this.tel = "";
    this.fax = "";
    this.email = "";
    this.staffKana = "";
    this.sikakuKbn = 0;
    this.birthday = null;
    this.kaisibi = null;
    this.syuryobi = null;
    this.koyoKeitai = 0;
    this.delFlg = 0;
    this.addDate = new Date();
    this.addUser = "";
    this.updDate = new Date();
    this.updUser = "";
  }

  // カスタムバリデーションメソッド
  validate(autoNoKbn: number): string[] {
    const errors: string[] = [];

    let validation = new MyCustomValidation(this.staffCode)
      .validateRequired("スタッフコードは必須です。")
      .validateNumeric("スタッフコードを正しく入力してください。")
      .validateStringRange(
        autoNoKbn == 1 ? "0" : "1",
        "9999999999",
        "スタッフコードを正しく入力してください。"
      );
    if (validation.hasErrors()) {
      errors.push(validation.getErrors()[0]);
    }


    validation = new MyCustomValidation(this.staffName)
      .validateRequired("スタッフ名は必須です。")
      .validateLength(
        1,
        20,
        "スタッフ名は1文字以上、20文字以内で入力してください。"
      );
    if (validation.hasErrors()) {
      errors.push(validation.getErrors()[0]);
    }

    validation = new MyCustomValidation(this.address1).validateLength(
      0,
      100,
      "住所１は100文字以内で入力してください。"
    );
    if (validation.hasErrors()) {
      errors.push(validation.getErrors()[0]);
    }


    validation = new MyCustomValidation(this.address2).validateLength(
      0,
      100,
      "住所２は100文字以内で入力してください。"
    );
    if (validation.hasErrors()) {
      errors.push(validation.getErrors()[0]);
    }


    validation = new MyCustomValidation(this.address3).validateLength(
      0,
      100,
      "住所３は100文字以内で入力してください。"
    );
    if (validation.hasErrors()) {
      errors.push(validation.getErrors()[0]);
    }


    validation = new MyCustomValidation(this.tel).validateLength(
      0,
      14,
      "電話番号は14文字以内で入力してください。"
    );
    if (validation.hasErrors()) {
      errors.push(validation.getErrors()[0]);
    }


    validation = new MyCustomValidation(this.fax).validateLength(
      0,
      14,
      "FAX番号は14文字以内で入力してください。"
    );
    if (validation.hasErrors()) {
      errors.push(validation.getErrors()[0]);
    }

    validation = new MyCustomValidation(this.email).validateLength(
      0,
      255,
      "メールアドレスは255文字以内で入力してください。"
    );
    if (validation.hasErrors()) {
      errors.push(validation.getErrors()[0]);
    }

    // その他のバリデーションルールをここに追加

    return errors;
  }
}

type updateStaffCallback = (item: any) => void;
type deleteStaffCallback = (item: any) => void;

export function actionStaff() {
  const StaffId: string = "StaffId";
  const isModalStaffVisible: Ref<boolean> = ref(false);
  const updateActionStaffCallback: Ref<updateStaffCallback | null> = ref(null);
  const deleteActionStaffCallback: Ref<deleteStaffCallback | null> = ref(null);

  async function showStaff(
    updatecallback: updateStaffCallback,
    deletecallback: deleteStaffCallback
  ): Promise<void> {
    isModalStaffVisible.value = true;
    updateActionStaffCallback.value = updatecallback;
    deleteActionStaffCallback.value = deletecallback;
  }

  async function closeModalStaff(): Promise<void> {
    isModalStaffVisible.value = false;
  }

  async function updateActionStaff(item: any): Promise<void> {
    if (updateActionStaffCallback.value) {
      updateActionStaffCallback.value(item); // コールバックにユーザーを渡す
    }
    await closeModalStaff();
  }

  async function deleteActionStaff(item: any): Promise<void> {
    if (deleteActionStaffCallback.value) {
      deleteActionStaffCallback.value(item); // コールバックにユーザーを渡す
    }
    await closeModalStaff();
  }

  function cancelActionStaff(): void {
    closeModalStaff();
  }

  return {
    StaffId,
    isModalStaffVisible,
    showStaff,
    closeModalStaff,
    cancelActionStaff,
    updateActionStaff,
    deleteActionStaff,
  };
}

//selectedActionCallback の型が CallbackFunction となっていますが、
//これを TblMUser 型の user オブジェクトを引数として受け取る関数に修正する必要があります。
//現在の実装ではコールバックが正しく実行されない可能性があります。
//selectedActionCallback の型が CallbackFunction となっていますが、
//これを TblMUser 型の user オブジェクトを引数として受け取る関数に修正する必要があります。
//現在の実装ではコールバックが正しく実行されない可能性があります。
type SelectedActionStaffSearchCallback = (item: any) => void;

export function useStaffSearch() {
  const StaffSearchId: string = "myStaffSearchId";
  const isModalStaffSearchVisible: Ref<boolean> = ref(false);
  const selectedActionStaffSearchCallback: Ref<SelectedActionStaffSearchCallback | null> =
    ref(null);

  async function showStaffSearch(
    callback: SelectedActionStaffSearchCallback
  ): Promise<void> {
    isModalStaffSearchVisible.value = true;
    selectedActionStaffSearchCallback.value = callback;
  }

  async function closeModalStaffSearch(): Promise<void> {
    isModalStaffSearchVisible.value = false;
  }

  async function selectedActionStaffSearch(item: any): Promise<void> {
    if (selectedActionStaffSearchCallback.value) {
      selectedActionStaffSearchCallback.value(item); // コールバックにユーザーを渡す
    }
    await closeModalStaffSearch();
  }

  function cancelActionStaffSearch(): void {
    closeModalStaffSearch();
  }

  return {
    StaffSearchId,
    isModalStaffSearchVisible,
    showStaffSearch,
    closeModalStaffSearch,
    cancelActionStaffSearch,
    selectedActionStaffSearch,
  };
}